import { unwrapResult, } from '@reduxjs/toolkit';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
export const useAssistantDispatch = () => useDispatch();
export const useAssistantSelector = useSelector;
export const useAssistantUnwrap = () => {
    const dispatch = useDispatch();
    return useCallback((asyncThunk) => dispatch(asyncThunk).then(unwrapResult), [dispatch]);
};
